import React from 'react'
import styled from 'styled-components'
import { PostAuthor } from './PostAuthor'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  color: #656565;
`

export const PostViewSubHeader = ({ author, date }) => {
  return (
    <Wrapper>
      {author && (
        <PostAuthor
          displayName={author.displayName}
          avatarImage={author.avatar?.childImageSharp}
          slug={author.fields.slug}
        />
      )}
      <small>{date}</small>
    </Wrapper>
  )
}
